import { imageDataToBase64 } from '@/common/images';
import { Camera } from '@/components/camera/component';

import { MobileHeader } from '@/components/workflow/mobile-header';
import { useBagAuditContext } from '../hook';

export const BagAuditAddLoadPhotosPage = () => {
	const { setPage, setEvaluatingBag } = useBagAuditContext();

	const handleAddPhoto = (imageData: ImageData[]) => {
		if (imageData.length === 0) {
			setPage('FORM');
			return;
		}

		const photoDataUrls = imageData.map((image) => {
			return `data:image/jpeg;base64,${imageDataToBase64(image, 'jpeg', 0.8)}`;
		});

		// Append new photos to existing photos array
		setEvaluatingBag((prev) => {
			if (!prev) return null;
			return {
				...prev,
				photos: [...prev.photos, ...photoDataUrls],
			};
		});

		// Navigate back to the form page
		setPage('FORM');
	};

	const handleBack = () => {
		setPage('FORM');
	};

	return (
		<div>
			<MobileHeader title="Add Load Photos" onBack={handleBack} />
			<Camera multiple onTakePhoto={handleAddPhoto} />
		</div>
	);
};
